<!--
 * @Author: ken yang
 * @Date: 2022-08-30 11:14:13
 * @LastEditTime: 2023-05-29 10:14:36
 * @LastEditors: ken yang
 * @Description: 布局入口
 * @FilePath: /uexch_admin/src/layout/AppLayout.vue
-->
<template>
  <Column class="AppLayout" y="s">
    <navbar class="w-100b" />
    <Row class="main-container bg-line w-100b">
      <Sidebar class="w-230 f-size-230 h-100b" />
      <!-- <Tags v-show="!isTag" /> -->
      <AppMain class="AppMain h-100b" />
    </Row>
  </Column>
</template>

<script setup>
import { Navbar, Sidebar, AppMain, Tags } from './components'

const isTag = $computed(() => {
  return localStorage.isTag || ''
})

onBeforeMount(() => { })
</script>

<style lang="scss">
.AppLayout {
  // width:100vw;
  .main-container{
    min-width: 1200px;
    // height:100vh;
    height: calc(100vh - 60px);
    overflow:auto;
    flex-grow: 1;
    background: #F4F6FA;
  }
  .AppMain{
    min-width: 970px;
    width: calc(100vw - 230px);
  }
}
</style>
